import React, { useRef, useEffect, useState } from 'react';
import './ContentImage.scss';

import { motion, useTransform, useScroll } from 'framer-motion';

import { homePage } from '../../../editable-stuff/config';
import GradientButton from '../../../Library/GradientButton/GradientButton';

export default function ContentImage() {
  const { scrollYProgress } = useScroll();
  const [hookedYPostion, setHookedYPosition] = useState(0);
  React.useEffect(() => {
    scrollYProgress.onChange((v) => setHookedYPosition(v));
  }, [scrollYProgress, setHookedYPosition]);

  return (
    <section id='content-image' className='full'>
      <div className='wave-top'>
        <svg
          fill='#f6f6f6'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 1000 300'
          preserveAspectRatio='none'
        >
          <path d='M 1000 299 l 2 -279 c -155 -36 -310 135 -415 164 c -102.64 28.35 -149 -32 -232 -31 c -80 1 -142 53 -229 80 c -65.54 20.34 -101 15 -126 11.61 v 54.39 z'></path>
          <path d='M 1000 286 l 2 -252 c -157 -43 -302 144 -405 178 c -101.11 33.38 -159 -47 -242 -46 c -80 1 -145.09 54.07 -229 87 c -65.21 25.59 -104.07 16.72 -126 10.61 v 22.39 z'></path>
          <path d='M 1000 300 l 1 -230.29 c -217 -12.71 -300.47 129.15 -404 156.29 c -103 27 -174 -30 -257 -29 c -80 1 -130.09 37.07 -214 70 c -61.23 24 -108 15.61 -126 10.61 v 22.39 z'></path>
        </svg>
      </div>
      <div className='row justify-content-between'>
        <div className='col-12 col-lg-6 p-0'>
          <div className='image'>
            <div className='tiles-gallery half'>
              <div className='tiles-wrap'>
                <motion.div
                  className='tiles-line'
                  // ref={elementRef}
                  // whileInView={{
                  //   transform: `translateX(6%) translateZ(0)`,
                  // }}

                  // animate={{ x: 0 }}
                  // style={{ scale: scaleY }}
                  // style={{
                  //   x,
                  //   // transform: `translateX(${x.get()}px) translateZ(0)`,
                  //   // scaleX: scrollYProgress,
                  //   // transform: 'translate(-7.4%, 0%) translate3d(94.9867px, 0px, 0px)',
                  // }}
                >
                  <div className='tiles-line-img'></div>
                  <div className='tiles-line-img'></div>

                  {homePage.contentImage.media.row1?.map((row, i) => (
                    <ImageItem
                      key={`row1-${i}`}
                      img={row.img}
                      title={row.title}
                    />
                  ))}
                </motion.div>
                <div className='tiles-line'>
                  {homePage.contentImage.media.row2?.map((row, i) => (
                    <ImageItem
                      key={`row2-${i}`}
                      img={row.img}
                      title={row.title}
                    />
                  ))}
                </div>
                <div className='tiles-line'>
                  {homePage.contentImage.media.row3?.map((row, i) => (
                    <ImageItem
                      key={`row3-${i}`}
                      img={row.img}
                      title={row.title}
                    />
                  ))}
                </div>
                <div className='tiles-line'>
                  {homePage.contentImage.media.row4?.map((row, i) => (
                    <ImageItem
                      key={`row4-${i}`}
                      img={row.img}
                      title={row.title}
                    />
                  ))}
                </div>
                <div className='tiles-line'>
                  {homePage.contentImage.media.row5?.map((row, i) => (
                    <ImageItem
                      key={`row5-${i}`}
                      img={row.img}
                      title={row.title}
                    />
                  ))}
                  <div className='tiles-line-img'></div>
                  <div className='tiles-line-img'></div>
                </div>
              </div>
            </div>
            <div className='wave-bottom half'>
              <svg
                fill='#f6f6f6'
                xmlns='http://www.w3.org/2000/svg'
                viewBox='0 0 1920.728 48.179'
              >
                <path
                  d='M0 48.18c14.1-9.664 74-21.354 114.258-27.97 73.8-12.129 159.97-9.137 319.07-11.114 33.083-.411 107.14-11.834 248-6.414 121.7 4.683 198.3 5.571 374.155 6.414 27.381.131 57.359 3.647 90.475 3.592 245.705-.4 186.882-9.861 418.3 1.214S1920 48.18 1920 48.18z'
                  opacity='.75'
                ></path>
                <path
                  d='M1920.728 48.007S1546.093-2.793 1393.65.121C1059.888 8.89 1018.31 25.272 750.7 25.272s-238.437-17.026-426.031-12.7S-.001 48.181-.001 48.181z'
                  opacity='.5'
                ></path>
                <path d='M0 48.179s245.842-31.161 392.892-31.161C515.063 19.879 685.621-7.835 829.849 2.484s177.947 14.534 232.126 14.534c275.221 0 239.131-3.569 414.479-14.43S1920 48.179 1920 48.179z'></path>
              </svg>
            </div>
          </div>
        </div>
        <div className='col-12 col-lg-4 mx-auto d-flex align-items-center'>
          <div className='text p-150'>
            <div className='headers mb-4'>
              <motion.h4
                initial={{ x: '-100px', opacity: 0 }}
                whileInView={{ x: '0', opacity: 1 }}
                transition={{ duration: 0.5 }}
              >
                {homePage.contentImage.title}
              </motion.h4>
              <motion.h2
                className='gradient'
                initial={{ x: '-100px', opacity: 0 }}
                whileInView={{ x: '0', opacity: 1 }}
                transition={{ duration: 0.5 }}
              >
                {homePage.contentImage.gradient_title}
              </motion.h2>
            </div>
            <motion.div
              className='content'
              initial={{ x: '-100px', opacity: 0 }}
              whileInView={{ x: '0', opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              {homePage.contentImage.description?.map((descp) => (
                <p>{descp}</p>
              ))}
            </motion.div>
            <GradientButton
              text={homePage.contentImage.button.text}
              link={homePage.contentImage.button.link}
              svg={homePage.contentImage.button.svg}
            />
          </div>
        </div>
      </div>
      <div className='wave-bottom half'>
        <svg
          fill='#f6f6f6'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 1920.728 48.179'
        >
          <path
            d='M0 48.18c14.1-9.664 74-21.354 114.258-27.97 73.8-12.129 159.97-9.137 319.07-11.114 33.083-.411 107.14-11.834 248-6.414 121.7 4.683 198.3 5.571 374.155 6.414 27.381.131 57.359 3.647 90.475 3.592 245.705-.4 186.882-9.861 418.3 1.214S1920 48.18 1920 48.18z'
            opacity='.75'
          ></path>
          <path
            d='M1920.728 48.007S1546.093-2.793 1393.65.121C1059.888 8.89 1018.31 25.272 750.7 25.272s-238.437-17.026-426.031-12.7S-.001 48.181-.001 48.181z'
            opacity='.5'
          ></path>
          <path d='M0 48.179s245.842-31.161 392.892-31.161C515.063 19.879 685.621-7.835 829.849 2.484s177.947 14.534 232.126 14.534c275.221 0 239.131-3.569 414.479-14.43S1920 48.179 1920 48.179z'></path>
        </svg>
      </div>
    </section>
  );
}
interface ImageItemProps {
  img: string;
  title: string;
}

const ImageItem = ({ img, title }: ImageItemProps) => {
  return (
    <div className='tiles-line-img'>
      <img
        loading='lazy'
        src={img}
        sizes='(min-width: 400px) 15vw, 40vw'
        width='100%'
        alt={title}
      />
    </div>
  );
};
